import { createSelector } from 'reselect';

import getCitiesAreas from '@core/reducers/areas/selectors/getCitiesAreas';

const getAreasByCityId = createSelector(
  getCitiesAreas,
  areas => cityId => {
    const cityAreas = cityId && areas[cityId];
    return cityAreas || [];
  },
);

export default getAreasByCityId;
